import useResizeObserver from "@react-hook/resize-observer";
import { useRef, ChangeEventHandler } from "react";
import { useLocalStorage } from "react-use";

import "./PermanentlyResizableTextarea.css";

// When dealing with multiple PermanentlyResizableTextarea components:
// Use the same commonWidth/setCommonWidth useState pair to keep widths in synchrony
interface PermanentlyResizableTextareaProps {
  id: string;
  rows: number;
  value: string;
  onChange: ChangeEventHandler<HTMLTextAreaElement>;
  placeholder?: string;
  minWidth?: number;
  commonWidth?: number;
  setCommonWidth: (n: number | undefined) => void;
}

const PermanentlyResizableTextarea = ({
  id,
  rows,
  value,
  onChange,
  placeholder,
  minWidth = 300,
  commonWidth,
  setCommonWidth,
}: PermanentlyResizableTextareaProps) => {
  const target = useRef<HTMLTextAreaElement | null>(null);

  const [height, setHeight] = useLocalStorage<number | undefined>(
    `${id}-height`
  );

  useResizeObserver(target, () => {
    setHeight(target.current?.offsetHeight);
    setCommonWidth(target.current?.offsetWidth);
  });

  return (
    <textarea
      ref={target}
      id={id}
      rows={rows}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="ResizableTextarea"
      style={{
        ...(commonWidth && height
          ? {
              width: `${commonWidth}px`,
              height: `${height}px`,
            }
          : {}),
        ...(minWidth
          ? {
              minWidth: `${minWidth}px`,
            }
          : {}),
      }}
    />
  );
};

export default PermanentlyResizableTextarea;
